/**
 * alerts service
 */

import Resource from './resource'

export default new Resource('alerts')



// WEBPACK FOOTER //
// ./src/libraries/services/alerts.js